import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export default function (ComposedComponent) {
  class RequireStandardPlanForUpgrade extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const { user } = this.props;
      if (user && user.isCustomPlan) {
        this.redirect(user.status === 'active' ? '/billing' : '/');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return connect(mapStateToProps)(RequireStandardPlanForUpgrade);
}
